import { Component, OnDestroy, OnInit } from '@angular/core';
import {OutwardHeaderComponent} from '../outward-header/outward-header.component'
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { OperatorFunction, Subject } from 'rxjs';
import { catchError, finalize, map,tap } from 'rxjs/operators';
import { MasterService } from 'src/app/shared/services/master.service';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { SortBy } from 'src/app/Enums/sortEnums';
import * as _ from "underscore";
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { OutwardService } from 'src/app/shared/services/outward.service';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import {InwardStatus} from 'src/app/Enums/inwardEnum';
import { filterData, OfficeFilter, outwardFilter } from 'src/app/shared/classes/filter';
import { ConfirmationModalComponent } from 'src/app/shared/components/confirmation-modal/confirmation-modal.component';
import { ComponentName, ModalSize } from 'src/app/Enums/usersFilterEnums';
import { Office } from 'src/app/shared/classes/users';
//import { EditOutwardComponent } from '../edit-outward/edit-outward.component';
import { Router } from '@angular/router';
import { Role } from '../../../Enum/role';
import { CancelPopupComponent } from '../view-outward/cancel-popup/cancel-popup.component';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';
import { OutwardStatus } from 'src/app/Enums/outwardEnum';


@Component({
  selector: 'app-outward-table',
  templateUrl: './outward-table.component.html',
  styleUrls: ['./outward-table.component.less']
})
export class OutwardTableComponent implements OnInit, OnDestroy {
    modalRef: BsModalRef;
    tableSetting: any;
    usersList: any;
    userModel: any;
    cityList: any;
    statusList:any;
    totalCount: number;
    InwardStatus:InwardStatus;
    currentIndex: number;
    p: number = 1;
    Roles:any;
    status:string;
    errorMessage: string;
    showError: boolean;
    showNoResult: boolean = false;
    displaysort: boolean = false;
    isPaginationChange: boolean = false;
    cityArray: Array<any> = new Array();
    registrationArray: Array<any> = new Array();
    statusArray: Array<any> = new Array();
    officeArray: Array<any> = new Array();
    reqId: number;
    request:any;
    requestName:string;
    regType: string;
   duedatecomparer:string;
    filterData = {} as filterData;
    itemsperPage: number = 10;
    userName: any;
    regDateTimeFrom:any;
    regDateTimeTo:any;
    officeID: number;
    officeName:string;
    countLength: number;
    selectedOffice:any;
    data : any = [];
    OutwardStatus = OutwardStatus;
  private service_URL: any;
  
  private unsubscribe$ =new Subject<void>();
    registrationList: any;
    
  
  constructor(
    private _masterService: MasterService,
    private outwardService: OutwardService,
    private _dataContextService: DataContextService,
    private modalService: BsModalService,
    private toast: ToastrService,
    private datePipe: DatePipe,
    private rounter:Router,
    private trackeromnitureservice:TrackerOmnitureService
    ) {
        this.filterData.page = 1;
    this.service_URL = ConstantsService;
  }

  ngOnInit(): void {
    //this.Roles="Admin";
    //Role.SecuritySupervisior;
    this.ResetOfficesObjects();
    this.outwardService.refreshPage
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
        this.isPaginationChange = false;
        this.ResetOfficesObjects();
        this.getOutwardData();
    });

        this.outwardService.refreshwithFilters
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => {
            this.isPaginationChange = false;
            this.ResetOfficesObjects();
            this.getOutwardData();
        });

        this.outwardService.deleteReg
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => {
          this.DeleteAlert(this.reqId,this.requestName,this.request);
        });

        // this.outwardService.deleteOffices
        // .pipe(takeUntil(this.unsubscribe$))
        // .subscribe(() => {
        //   this.DeleteAlert(this.officeID, this.selectedOffice);
        // });

        this.tableSetting = {
            columns: this.tableSettingColumns()
        };

        //this.getUsers();
        this.getOutwardData();        
        
        var username = localStorage.getItem('email');
        username = username.split('@')[0];
        this.trackeromnitureservice.trackPageloadData('outward',username);
        this.trackeromnitureservice.trackPage("pageView");
   
  }
  
  ResetOfficesObjects() {
    outwardFilter.regTypeList=[];
    outwardFilter.cityList=[];
    outwardFilter.statusList=[];
    outwardFilter.officeList=[];
    this.regDateTimeFrom=null;
    this.regDateTimeTo=null;
    this.userName = '';
    this.filterData.page = 1;
}

  searchOfficeByName(val) {
    this.isPaginationChange = false;
    this.userName = val.username;
    this.filterData.page = 1;
    
    this.regDateTimeFrom = val.fdate;
    this.regDateTimeTo = val.edate;
    this.getOutwardData();
}

PrepareUsersObj() {
  
    //   console.log(this.regDateTimeFrom.slice(0,11) + '00:00:00.000Z');
    if(this.regDateTimeFrom == null)
      { 
        this.regDateTimeFrom = new Date();
        this.regDateTimeFrom.setDate(this.regDateTimeFrom.getDate()-7);        
      }
      if(this.regDateTimeTo == null)
      {
        this.regDateTimeTo = new Date();        
      }
      let params = {
          RequestType : outwardFilter.regTypeList,
          City: outwardFilter.cityList,
          Office: outwardFilter.officeList,
          Status : outwardFilter.statusList,
          ReceivedBy : [],
         
          SearchByName: this.userName==undefined?"":this.userName,
          SortRequestName:"",
          PageNo: this.filterData.page,
          RequestDateFrom :this.regDateTimeFrom,
          RequestDateTo : this.regDateTimeTo,
          LoggedinUserEmail:localStorage.getItem('email'),
          IsMyRequest:true

      };
    
      return params;
    }
    

PrepareUsersObj1() {
  //Converting Status Filter response to Boolean 
  var sArray: Array<boolean> = new Array();
  
  OfficeFilter.statusList.forEach(element => {
    element === 'Active' ? sArray.push(true) : sArray.push(false);
  });

  let params = {
      // Status: OfficeFilter.statusList,
      Status: sArray,       
      // Role: OfficeFilter.roleList,
      // Office: UsersFilterService.officesList,
      City: OfficeFilter.cityList,
      SearchByName: this.userName,
      PageNo: this.filterData.page
  };

  return params;
}

//get the city list from api
loadTypeOptions(typedata: any) {
    this.registrationList = typedata;
    this.registrationArray = typedata;
    if (this.registrationArray) {
        this.registrationArray.forEach(item => {
            item.description = item.name; 
        })
    }
    if (outwardFilter.regTypeList.length == 0) {
        this.registrationArray.forEach(item => {
            item.isCheck = true;
        })
    }
    else {
        this.registrationArray.forEach(item => {
            outwardFilter.regTypeList.forEach(item1 => {
                if (item.description == item1) {
                    item.isCheck = true;
                } 
            })
        })
    }
    this.tableSetting.columns[3].isFilterIcon = true;
  }


editOutwardReq(val)
{
    this.rounter.navigate(['/EditOutward', val]); 
}

//get the status list from api
loadStatusOptions(statusdata: any) {
    this.statusList = statusdata;
    this.statusArray = statusdata;
    if (this.statusArray) {
        this.statusArray.forEach(item => {
            item.description = item.name;
        })
    }
    if (outwardFilter.statusList.length == 0) {
        this.statusArray.forEach(item => {
            item.isCheck = true;
        })
    }
    else {
        this.statusArray.forEach(item => {
            outwardFilter.statusList.forEach(item1=>{
                if (item.description == item1) {
                    item.isCheck = true;
                } 
            })
        })
    }
    this.tableSetting.columns[4].isFilterIcon = true;
  }


setIntialPageCount(totalrecords : number)
{
    //this.totalCount = totalCount;
    this.isPaginationChange = true;
    if (totalrecords > this.itemsperPage) {
        this.countLength = this.itemsperPage;
    }
    else {
        this.countLength = totalrecords;
    }
}


getOutwardData() {

    let data = this.PrepareUsersObj();

    this._dataContextService.postDatawithValues<any>(this.service_URL.OutwardDetails.GetOutwardRequestsByFilter, data)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(res => {
  
   this.status=res.status;
   this.duedatecomparer=new Date().toISOString();
    this.usersList =res.gatepassrequests;
    this.usersList.forEach(element => {

        if(element.revisedDate!=null)
        if (element.returnDateTime !== element.revisedDate) {
            element.returnDateTime = element.revisedDate;
          }
       
        const dueDate = new Date(this.duedatecomparer);
        const returnDate = new Date(element.returnDateTime);

        const timeDifference = dueDate.getTime() - returnDate.getTime();

        const daysDifference = timeDifference / (1000 * 3600 * 24);
        const hoursDifference = Math.abs(timeDifference / (1000 * 3600));
        const days = Math.abs(Math.round(daysDifference));
        
        if (days === 1 || days === 2 || hoursDifference <= 48) {
            element.duedatebeforetwodays = true;
        } else {
            element.duedatebeforetwodays = false;
        }
        
    
    });
    this.totalCount=res.totalRecords;
    this.loadTypeOptions(res.type);
    this.loadStatusOptions(res.status); 
    if(!this.isPaginationChange){this.setIntialPageCount(this.totalCount);}

    })

    }

    loadreqTypeOption(reqtypedata: any) {
        this.registrationArray = reqtypedata;
       // this.checkFilterOptions(this.registrationArray);
    }

    checkFilterOptions(filterArray, filterList) {
        if (filterArray) {
            filterArray.forEach(item => {
                item.description = item.name;
            })

            // _.each(filterArray, function (item) {
            //     item.description = item.name;
            // })
        }
        if (filterList.length == 0) {
            filterArray.forEach(item =>{
                item.isCheck = true;
            })

            // _.each(filterArray, function (item) {
            //     item.isCheck = true;
            // })
        }
        else {
            filterArray.forEach(item => {
                filterList.forEach(item1 => {
                    if (item.description == item1) {
                        item.isCheck = true;
                    } 
                })
            })


            // _.each(filterArray, function (item) {
            //     _.each(filterList, function (item1) {
            //         if (item.description == item1) {
            //             item.isCheck = true;
            //         }
            //     })
            // })
        }
    }




    detailedIOnfo(val){
// this.rounter.navigate(['ViewOutward']);
 this.rounter.navigate(['/ViewOutward', val]); 
//  console.log(val);
}
checkFilterApplied(val) {
  this.isPaginationChange = false;
  if (val) {
      this.filterData.sortBy = outwardFilter.sortBy;
      this.filterData.sortOrder = outwardFilter.sortOrder;
      this.filterData.page = 1;
      this.p = 1;
      this.checkFilterValue();
      this.getOutwardData();
  } else {
      this.usersList = [];
  }
}

checkFilterValue() {
  this.tableSetting.columns.forEach(item => {
      if (outwardFilter.sortBy != item.sortBy) {
          item.isFilterApplied = false;
      }
  })
}
changeCurrentPage(event) {
  //this.isPaginationChange = true;
  this.filterData.page = event.page;
  if ((this.totalCount / (this.filterData.page * this.itemsperPage) > 1)) {
      this.countLength = this.filterData.page * this.itemsperPage
  }
  else {
      this.countLength = this.totalCount;
  }
  this.getOutwardData();
}

  showSortingPopup(obj) {

    _.each(this.tableSetting.columns, function (item) {
        if (item.Id != obj.Id) {
            item.displaysort = false;
        }
    })
    obj.displaysort = !obj.displaysort;
}


hideDropdowns() {
  _.each(this.tableSetting.columns, function (item) {
      item.displaysort = false;
  })
}

closeDropDown() {
  _.each(this.usersList, function (item) {
      item.showAssigneeDropdown = false;
      item.showStatusDropdown = false;
  })

}

  tableSettingColumns() {
    return [
        
        {
            Id: 1,
            title: "Request ID",
            classes: "ui_size_md",
            //isSortable: true,
            isResNameSortN: true,
            cityDropdown: true,
            isFilterApplied: false
            //displaysort: false,
            
        },
        {
            Id: 2,
            title: "G.P. No.",
            classes: "ui_size_md",
            //isResNameSortN: true,
            isFilterApplied: false,
            displaysort: false,
            isFilterIcon: false
        },
        {
           
          Id: 3,
          title: "Request Name",
          classes: "ui_size_md_small",
          isSortable: true,
          statusDropdown: true,               
          isFilterApplied: false,
          displaysort: false,
          isOnlyFilter: true,
          isFilterIcon: false
        },
        {
            Id:4,
            title: "Request Type",
            classes: "ui_size_md_small",            
            isSortable: true,
            requestTypeDropDown: true,
            //isResNameSortN: true,
            //filterWrapper: "event-type-dropdown",
            sortBy: SortBy.Reg,
            isFilterApplied: false,
            displaysort: false,
            isOnlyFilter: true,
            isFilterIcon: true
        },
        {
          
            Id:5,
            title: "Status",
            classes: "ui_size_md_small",            
            isSortable: true,
            statusDropdown: true,
            //isResNameSortN: true,
            //filterWrapper: "event-type-dropdown",
            sortBy: SortBy.Status,
            isFilterApplied: false,
            displaysort: false,
            isOnlyFilter: true,
            isFilterIcon: true

        },
        {
            Id: 6,
            title: "Request Date & Time",
            classes: "ui_size_md",
            isSortable: false,
            isFilterApplied: false,
            sortBy: SortBy.RequestDate,
            displaysort: false,
            isOnlyFilter: true,
            isFilterIcon: true
        },
        {
            Id: 7,
            title: "Due Date & Time",
            classes: "ui_size_md",
            isSortable: false,
            isFilterApplied: false,
            sortBy: SortBy.DueDate,
            displaysort: false,
            isOnlyFilter: false,
            isFilterIcon: false
        }
        
    ];
}

DeleteAlert(rreqId: number, reqname:string,req:any) {
    if(req.status == 'false'){
        this.toast.error("Request was already deleted");
        return ;
    }
    let url = this.service_URL.OutwardDetails.DeleteRequest + '/' + rreqId;       
    // let data = {
    //   id: selectedOfficeID
    // };
        this._dataContextService.postDatawithValuesForDel<any>(url)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(res => {
           
             if(res=="1"){
                this.toast.error("Outward Request was deleted");
                //this.isPaginationChange = false;
                this.getOutwardData();
            }
            else{
                this.toast.error("Some thing went on wrong..")
            }
            
        })
    }
    DeclineRequest(selectedRequest : any){
        this.modalRef = this.modalService.show(CancelPopupComponent,{
          initialState : {
            selectedRequest : selectedRequest
          }
        })
        this.modalRef.setClass(ModalSize.Large);
        // let params = {
        //   statusId : InwardStatus.Declined,
        //   requestId : this.viewData.requestId
        // }
      
        // this._dataContextService.postDatawithValues<any>(this.service_URL.InwardDetails.UpdateStatus,params)
        // .pipe(takeUntil(this.unsubscribe$))
        // .subscribe((res) => {
        //   if(res == 1){
        //     this.toast.success("Materials Successfully Checked");
        //     this.GetById(this.id);
        //     window.location.reload();
        //   }
        //   else{
        //     this.toast.error("Something went wrong");
        //   }
        // })
      }
ngOnDestroy(){
  this.unsubscribe$.next();

  this.unsubscribe$.complete();


}

deleteReg(requestId: number,requestName:string,request:any){

    this.reqId = requestId;
    this.requestName=requestName;
    this.request=request;
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
   
    this.modalRef.setClass(ModalSize.Small);
    this.modalRef.content.title = 'Delete Registration';
    this.modalRef.content.description = 'Are you sure you want to delete <b>' + requestName + ' registration </b>?';
    this.modalRef.content.buttonsTitle = {
        dismiss: 'Cancel',
        confirm: 'Delete',
        component: ComponentName.Outward
        
    }
    
}


}
